/**
 * Layout options for the Toggle Input subcomponent.
 */
export var ToggleInputLayout;
(function (ToggleInputLayout) {
    /**
     * Show the label before the input.
     */
    ToggleInputLayout["LabelFirst"] = "LabelFirst";
    /**
     * Show the input before the label
     */
    ToggleInputLayout["InputFirst"] = "InputFirst";
})(ToggleInputLayout || (ToggleInputLayout = {}));
